// Copyright ©️ 2026 eVolve MEP, LLC

import { type TaskPaginated, type Task, useEvolveDelete } from '@evolvemep/api-ts';
import { Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { VariableTrackingModal } from 'components/Mantine/Modals/VariableTrackingModal';

type Props = {
  task: Task | TaskPaginated | null;
  onClose: () => void;
  onTaskDeleted: () => void;
};

export const DeleteTaskModal = ({ task: taskToDelete, onClose, onTaskDeleted }: Props) => {
  const { apiCall: deleteTaskApiCall } = useEvolveDelete(`shop/task/:taskId`);

  return (
    <VariableTrackingModal
      title="Delete task"
      variable={taskToDelete}
      onConfirm={async (task) => {
        await deleteTaskApiCall({ url: `shop/task/${task.taskId}` }).then(() => {
          notifications.show({
            title: 'Successfully deleted',
            message: `Deleted task ${task.taskName}`,
            color: 'green',
          });
          onTaskDeleted();
        });
      }}
      onClose={onClose}
      confirmationText="Delete"
    >
      {(task) => (
        <Text>
          Are you sure you want to delete <b>{task.taskName}</b>?
        </Text>
      )}
    </VariableTrackingModal>
  );
};
